import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'
import {
  openModal,
  resetOrder,
  selectOrder,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { ArrowRight } from '../../icons'
import { ButtonLarge } from '../..'

const GuestButtonsView = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin: 1rem 0 4rem;
  gap: 2rem;
  padding: 0 ${(props) => props.theme.layout.padding};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    gap: 1rem;
    margin: 1.5rem 0 2.5rem;
    padding: 0 ${(props) => props.theme.layout.paddingMobile};
  }
`

const GuestButtons = React.forwardRef(
  (props, ref: React.LegacyRef<HTMLDivElement> | undefined) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const currentOrder = useAppSelector(selectOrder)
    const { revenueCenter, serviceType, cart } = currentOrder
    const isCurrentOrder =
      revenueCenter && serviceType && (cart?.length ?? 0) > 0

    const continueCurrent = () => {
      navigate(revenueCenter ? `/menu/${revenueCenter.slug}` : '/order-type')
    }

    const startNewOrder = () => {
      dispatch(resetOrder())
      navigate(`/order-type`)
    }

    const login = () => {
      dispatch(openModal({ type: 'login' }))
    }

    return (
      <GuestButtonsView ref={ref}>
        <ButtonLarge onClick={login} color="secondary">
          Sign in or sign up
        </ButtonLarge>
        <ButtonLarge
          onClick={isCurrentOrder ? continueCurrent : startNewOrder}
          text={isCurrentOrder ? 'Continue Order' : 'Order Now'}
          color="primary"
        >
          <ArrowRight
            size={22}
            strokeWidth={2}
            style={{ position: 'relative', top: 3 }}
          />
        </ButtonLarge>
      </GuestButtonsView>
    )
  }
)

export default GuestButtons
